import { useWatch } from 'antd/es/form/Form';
import { useCallback, useEffect, useMemo } from 'react';
import { FormInstance } from 'components';
import { DataToEditType } from 'components/common/ContactFieldManager/ContactInfoForm/index';
import {
  resetEditOptionType,
  resetOptionType,
  setEditOptionType,
  setOptionType,
} from 'components/common/ContactFieldManager/contactFieldManagerSlice';
import { useAppDispatch } from 'store/hooks';
import { useTypedSelector } from 'store/store';
import { ContactInfoFieldKeyType } from 'typings/form';

export const useContactInfoForm = (
  form: FormInstance,
  onCancel: () => void,
  dataToEdit?: DataToEditType | undefined
) => {
  const optionType = useTypedSelector((state) => state.contactFieldManager.optionType);
  const editOptionType = useTypedSelector((state) => state.contactFieldManager.editOptionType);
  const dispatch = useAppDispatch();
  const valueField = useWatch(dataToEdit ? 'edit_value' : 'value', form);
  const typeField = useWatch(dataToEdit ? 'edit_type' : 'type', form);
  const isChanged = useMemo(() => {
    return [valueField, typeField].some((value) => value !== undefined && value !== '');
  }, [valueField, typeField]);

  const onOptionSelect = useCallback(
    (value: ContactInfoFieldKeyType) => {
      if (PHONE_TYPE.includes(optionType as string) !== PHONE_TYPE.includes(value)) {
        if (dataToEdit) {
          form.setFieldsValue({ edit_value: '' }); // Explicitly clear the field value
        } else {
          form.setFieldsValue({ value: '' }); // Explicitly clear the field value
        }
      }
      if (dataToEdit) {
        if (editOptionType !== value) {
          dispatch(setEditOptionType(value));
        }
      } else {
        if (optionType !== value) {
          dispatch(setOptionType(value));
        }
      }
    },
    [form, optionType, dispatch, dataToEdit, editOptionType]
  );
  const onCancelClick = useCallback(() => {
    if (dataToEdit) {
      dispatch(resetEditOptionType());
    } else {
      dispatch(resetOptionType());
    }
    onCancel();
  }, [onCancel, dispatch, dataToEdit]);

  useEffect(() => {
    if (dataToEdit) {
      form.setFieldsValue(dataToEdit);
    }
    if (dataToEdit?.edit_type) {
      dispatch(setEditOptionType(dataToEdit.edit_type));
    }
  }, [dataToEdit, dispatch, form]);

  return {
    onOptionSelect,
    onCancelClick,
    optionType,
    editOptionType,
    form,
    isChanged,
  };
};

export const PHONE_TYPE = ['LANDLINE', 'MOBILE', 'FAX', 'VIBER', 'WHATS_APP'];
